import { useState, useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { LangText } from '@/components'
import classNames from 'classnames'
import { Form, Input, message } from 'antd'
import Protocol from '@/components/Protocol'
import { useNavigate } from 'react-router-dom'
import useModel from '../../useModel'

interface EmailFormProps {
  protocolChecked: boolean
  setProtocolChecked: (value: boolean) => void
}

const EmailForm = (props: EmailFormProps) => {
  const { protocolChecked, setProtocolChecked } = props;
  const { t } = useTranslation()
  const [form] = Form.useForm()
  const [isCodeLogin, setIsCodeLogin] = useState(false)
  const navigate = useNavigate()
  const { loading, codeLoading, countdown, sendCaptcha, loginByPassword, loginByCaptcha } = useModel()

  const [isButtonDisabled, setIsButtonDisabled] = useState(false);
  // 监听表单字段变化
  const formValues = Form.useWatch([], form);

  useEffect(() => {
    form.validateFields({ validateOnly: true }).then(() => {
      setIsButtonDisabled(false || !protocolChecked);
    }).catch(() => setIsButtonDisabled(true))
  }, [form, formValues, protocolChecked])

  const handleSendCode = async () => {
    form.validateFields(['email']).then(values => {
      sendCaptcha(values.email);
    })
  };

  const handleSubmit = async () => {
    try {
      if (!protocolChecked) {
        message.error(t('55a0f085'));
        return;
      }

      if (isCodeLogin) {
        // 验证码登录
        const values = await form.validateFields(['email', 'code']);
        await loginByCaptcha({
          account: values.email,
          captcha: values.code,
        });
      } else {
        // 密码登录
        const values = await form.validateFields(['email', 'password']);
        await loginByPassword({
          account: values.email,
          password: values.password,
        });
      }
    } catch (error) {
      console.error('表单验证失败:', error);
    }
  };

  return (
    <Form form={form} layout="vertical" className='!mt-4 leading-[1.5]' onFinish={handleSubmit}>
      <Form.Item
        name='email'
        required
        validateTrigger='onBlur'
        label={<LangText lngKey='9b1c6681' className='text-[16px] font-bold'>{t('9b1c6681')}</LangText>}
        rules={[
          { required: true, message: t('f51ccec8') },
          { type: 'email', message: t('aba0aa71') }
        ]}
      >
        <Input placeholder={t('5e21b2f8')} className='h-[44px]' disabled={codeLoading} />
      </Form.Item>
      {
        isCodeLogin ?
          (
            <Form.Item required className='w-full' label={<LangText lngKey='2638a4d4' className='text-[16px] font-bold'>{t('2638a4d4')}</LangText>}>
              <div className='flex w-full'>
                <Form.Item name='code' noStyle className='flex-1' rules={[{ required: true, message: t('b68e8285') }]}>
                  <Input placeholder={t('da67c20b')} className='h-[44px]' />
                </Form.Item>
                <div
                  className={`shrink-0 border border-[#5a52ff] rounded-[4px] ml-2 px-3 flex items-center justify-center cursor-pointer ${countdown > 0 || codeLoading ? 'opacity-50 cursor-not-allowed' : ''
                    }`}
                  onClick={handleSendCode}
                >
                  <LangText lngKey={codeLoading ? '141d18c7' : 'fbdf3b19'} className='text-[14px] text-[#5a52ff] text-nowrap'>
                    {codeLoading ? t('141d18c7') : countdown > 0 ? `${countdown}s` : t('fbdf3b19')}
                  </LangText>
                </div>
              </div>
            </Form.Item>
          ) :
          <div className='relative'>
            <Form.Item name='password' required label={<LangText lngKey='70d6495a' className='text-[16px] font-bold'>{t('70d6495a')}</LangText>} rules={[{ required: true, message: t('f039ef62') }]}>
              <Input.Password placeholder={t('d249273b')} className='h-[44px]' />
            </Form.Item>
            {/* <div className='absolute right-0 top-[83px] cursor-pointer'>
              <LangText lngKey='a6cf7c7d' className='text-[12px] text-[#666666]'>{t('a6cf7c7d')}</LangText>
            </div> */}
          </div>
      }
      <div className='mt-[26px]'>
        <LangText onClick={() => setIsCodeLogin(!isCodeLogin)} lngKey={ isCodeLogin ? '087253c0' : '104a0260'} className='text-[14px] text-[#5a52ff] cursor-pointer'>{isCodeLogin ? t('087253c0') : t('104a0260')}</LangText>
      </div>
      <div className='mt-5'>
        <Protocol value={protocolChecked} onChange={setProtocolChecked} />
      </div>
      <button
        type='submit'
        className={classNames(`w-full mt-3 rounded-[24px] bg-linear-to-r from-[#a75aff] to-[#4b51ff] h-[44px]`, {
          'opacity-60': isButtonDisabled,
          'cursor-not-allowed': isButtonDisabled,
          'cursor-pointer': !isButtonDisabled,
        })}
        disabled={isButtonDisabled}
      >
        <LangText lngKey={loading ? 'fe45f26a' : 'cb5d1a1c'} className='text-[15px] text-white'>{loading ? t('fe45f26a') : t('cb5d1a1c')}</LangText>
      </button>
      <div className='flex justify-center items-center mt-4'>
        <LangText lngKey='88a2dfb0' className='text-[14px]'>{t('88a2dfb0')}</LangText>
        &nbsp;
        <LangText onClick={() => navigate('/signup', { replace: true })} lngKey='930ab4e1' className='text-[14px] text-[#5a52ff] cursor-pointer'>{t('930ab4e1')}</LangText>
      </div>
    </Form>
  )
}

export default EmailForm